export const BRANDS_START = 'BRANDS_START';
export const BRANDS_SUCCESS = 'BRANDS_SUCCESS';
export const BRANDS_FAILED = 'BRANDS_FAILED';

export const GET_STORE_BRANDS_START = 'GET_STORE_BRANDS_START';
export const GET_STORE_BRANDS_SUCCESS = 'GET_STORE_BRANDS_SUCCESS';
export const GET_STORE_BRANDS_FAILED = 'GET_STORE_BRANDS_FAILED';

export const GET_ALL_BRANDS_START = 'GET_ALL_BRANDS_START';
export const GET_ALL_BRANDS_SUCCESS = 'GET_ALL_BRANDS_SUCCESS';
export const GET_ALL_BRANDS_FAILED = 'GET_ALL_BRANDS_FAILED';

export const getBrandsStart = () => ({
  type: BRANDS_START
});

export const getBrandsSuccess = (data, directDropShipAttr, affiliateAttr, skuLike) => ({
  type: BRANDS_SUCCESS,
  data,
  directDropShipAttr,
  affiliateAttr,
  skuLike
});

export const getBrandsFailed = () => ({
  type: BRANDS_FAILED
});

export const getStoreBrandsStart = () => ({
  type: GET_STORE_BRANDS_START
});

export const getStoreBrandsSuccess = (data) => ({
  type: GET_STORE_BRANDS_SUCCESS,
  data
});

export const getStoreBrandsFailed = () => ({
  type: GET_STORE_BRANDS_FAILED
});

export const getAllBrandsStart = () => ({
  type: GET_ALL_BRANDS_START
});

export const getAllBrandsSuccess = (data) => ({
  type: GET_ALL_BRANDS_SUCCESS,
  data
});

export const getAllBrandsFailed = () => ({
  type: GET_ALL_BRANDS_FAILED
});
